// extracted by mini-css-extract-plugin
export default {"content":"ApprovePaymentModal_content__zyZHj"};